<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">{{head}}</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="Close()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-xl-12 mt-4">
                        <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                            <mat-label>Collection Date</mat-label>
                            <input matInput [matDatepicker]="startDatePicker" [min]="date"
                                formControlName="collectionDate" autocomplete="off"
                                placeholder="Select collection Date" class="custom-input-border"
                                (click)="startDatePicker.open()" readonly>
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker" style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker ></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-xl-12 mt-4" >

                        <mat-form-field appearance="fill" hideRequiredMarker
                        [ngClass]="'textArea-mat-field'" style="border-radius: 0 !important;">
                        <mat-label>Comments / Notes</mat-label>
                        <textarea rows="4" matInput type="text" placeholder="Enter comments / notes"
                            formControlName="comments" autocomplete="off" specialIsAlphaNumeric
                            class="col-12"></textarea>
                    </mat-form-field>
                      </div>

                    </div>
                    <div class="row mt-4">
                        <div class="col-xl-12 d-flex justify-content-end button-style">
                            <button class="btn btn-secondary mr-3" (click)="Submit()">
                                Submit
                            </button>
                            <button class="btn btn-primary" (click)="Close()">
                                Cancel
                            </button>
                        </div>
                    </div>
            </form>
        </div>
    </div>
</div>